var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"span__1-red"},[_vm._v(" "+_vm._s(_vm.semana.intervalo)+" / Semana "+_vm._s(_vm.semana.semana)+" ")]),_c('h4',{staticClass:"mt-2"},[_c('b',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }